import { AnimationFactory } from './factory';

module.exports = new AnimationFactory();
